import {Artist} from "../../utils/artist.utils";

// Riize assets
import section1BgRiize from "./riize/home/section1/section1-bg.png";
import section1TitleRiize from "./riize/home/section1/section1-title.png";
import riizeLottie from "./riize/home/section1/riize.json";
import section2RiizeImg1 from "./riize/home/section2/section2-riize-01.png";
import section2RiizeImg2 from "./riize/home/section2/section2-riize-02.png";
import section2RiizeImg3 from "./riize/home/section2/section2-riize-03.png";
import section3BgRiize from "./riize/home/section3/section3-bg.png";
import section3ContentRiize from "./riize/home/section3/section3-content.png";
import section4Img1Riize from "./riize/home/section4/section4-1.png";
import section4Img2Riize from "./riize/home/section4/section4-2.png";
import section4Img3Riize from "./riize/home/section4/section4-3.png";
import section4RiizeBgStarImg from "./riize/home/section4/section4-background-star.png";
import section6Img2Riize from "./riize/home/section6/section6-2.png";
import arrowIconRiize from "./riize/arrow.png";

// Aespa assets
import section1BgAespa from "./aespa/home/section1/section1-bg.png";
import section1TitleAespa from "./aespa/home/section1/section1-title.png";
import aespaLottie from "./aespa/home/section1/aespa.json";
import section2AespaImg1 from "./aespa/home/section2/section2-01.png";
import section2AespaImg2 from "./aespa/home/section2/section2-02.png";
import section2AespaImg3 from "./aespa/home/section2/section2-03.png";
import section3BgAespa from "./aespa/home/section3/section3-bg.png";
import section3ContentAespa from "./aespa/home/section3/section3-content.png";
import section4Img1Aespa from "./aespa/home/section4/section4-1.png";
import section4Img2Aespa from "./aespa/home/section4/section4-2.png";
import section4Img3Aespa from "./aespa/home/section4/section4-3.png";
import section4AespaBgStarImg from "./aespa/home/section4/section4-background-star.png";
import section6Img2Aespa from "./aespa/home/section6/section6-2.png";
import arrowIconAespa from "./aespa/arrow.png";

export type Assets = {
  section1: {
    bg: string;
    title: string;
    lottie: unknown;
  };
  section2: {
    slides: [string, string, string];
  };
  section3: {
    bg: string;
    content: string;
  };
  section4: {
    steps: [string, string, string];
    backgroundStar: string;
  };
  section6: {
    image: string;
  };
  arrow: string;
};

type HomeAssets = {
  [key in Artist]: Assets;
};

export const HOME_ASSETS: HomeAssets = {
  riize: {
    section1: {
      bg: section1BgRiize,
      title: section1TitleRiize,
      lottie: riizeLottie,
    },
    section2: {
      slides: [section2RiizeImg1, section2RiizeImg2, section2RiizeImg3],
    },
    section3: {
      bg: section3BgRiize,
      content: section3ContentRiize,
    },
    section4: {
      steps: [section4Img1Riize, section4Img2Riize, section4Img3Riize],
      backgroundStar: section4RiizeBgStarImg,
    },
    section6: {
      image: section6Img2Riize,
    },
    arrow: arrowIconRiize,
  },
  aespa: {
    section1: {
      bg: section1BgAespa,
      title: section1TitleAespa,
      lottie: aespaLottie,
    },
    section2: {
      slides: [section2AespaImg1, section2AespaImg2, section2AespaImg3],
    },
    section3: {
      bg: section3BgAespa,
      content: section3ContentAespa,
    },
    section4: {
      steps: [section4Img1Aespa, section4Img2Aespa, section4Img3Aespa],
      backgroundStar: section4AespaBgStarImg,
    },
    section6: {
      image: section6Img2Aespa,
    },
    arrow: arrowIconAespa,
  },
} as const;
